// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 100vh;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Green button style for Approved state */
mc-button.approved::part(button) {
  background-color: #40AB35 !important;
  color: #FFFFFF !important;
}
mc-button.approved::part(icon) {
  fill: #FFFFFF !important;
}
.main-heading{
    margin-bottom: 1.5rem !important;
}
.uplaod-section-sub{
    display: flex;

}

.po-locations-section {
    margin-top: 2rem;
    padding: 1rem 0;
}

.section-title {
    font-size: 1.75rem;
    font-weight: 700;
    color: #0a3d62;
    margin-bottom: 0.5rem;
}

.section-subtitle {
    color: #555;
    margin-bottom: 1.5rem;
}

.po-cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
}

.po-card {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.08);
    padding: 1rem 1.5rem;
    transition: transform 0.3s, box-shadow 0.3s;
}

.po-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0,0,0,0.12);
}

.po-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}

.po-number {
    font-size: 1.2rem;
    font-weight: 600;
    color: #0a3d62;
}

.po-badge {
    background-color: #4ade80; /* green */
    color: #fff;
    font-weight: 600;
    padding: 0.25rem 0.75rem;
    border-radius: 12px;
    font-size: 0.85rem;
}

.charge-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.charge-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0;
    border-bottom: 1px solid #eee;
}

.charge-item:last-child {
    border-bottom: none;
}

.charge-id {
    font-weight: 500;
    color: #333;
}

.charge-link {
    color: #1d4ed8;
    font-weight: 500;
    text-decoration: none;
}

.charge-link:hover {
    text-decoration: underline;
}

.success-text {
    margin-top: 1.5rem;
    color: #16a34a;
    font-weight: 600;
    font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/Components/RequestCharge/Requestor.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0CAA0C;AAC1C;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;IACI,gCAAgC;AACpC;AACA;IACI,aAAa;;AAEjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uCAAuC;IACvC,oBAAoB;IACpB,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB,EAAE,UAAU;IACrC,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 100vh;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Green button style for Approved state */\nmc-button.approved::part(button) {\n  background-color: #40AB35 !important;\n  color: #FFFFFF !important;\n}\nmc-button.approved::part(icon) {\n  fill: #FFFFFF !important;\n}\n.main-heading{\n    margin-bottom: 1.5rem !important;\n}\n.uplaod-section-sub{\n    display: flex;\n\n}\n\n.po-locations-section {\n    margin-top: 2rem;\n    padding: 1rem 0;\n}\n\n.section-title {\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: #0a3d62;\n    margin-bottom: 0.5rem;\n}\n\n.section-subtitle {\n    color: #555;\n    margin-bottom: 1.5rem;\n}\n\n.po-cards-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 1.5rem;\n}\n\n.po-card {\n    background-color: #fff;\n    border-radius: 12px;\n    box-shadow: 0 4px 10px rgba(0,0,0,0.08);\n    padding: 1rem 1.5rem;\n    transition: transform 0.3s, box-shadow 0.3s;\n}\n\n.po-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 20px rgba(0,0,0,0.12);\n}\n\n.po-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1rem;\n}\n\n.po-number {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #0a3d62;\n}\n\n.po-badge {\n    background-color: #4ade80; /* green */\n    color: #fff;\n    font-weight: 600;\n    padding: 0.25rem 0.75rem;\n    border-radius: 12px;\n    font-size: 0.85rem;\n}\n\n.charge-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.charge-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.5rem 0;\n    border-bottom: 1px solid #eee;\n}\n\n.charge-item:last-child {\n    border-bottom: none;\n}\n\n.charge-id {\n    font-weight: 500;\n    color: #333;\n}\n\n.charge-link {\n    color: #1d4ed8;\n    font-weight: 500;\n    text-decoration: none;\n}\n\n.charge-link:hover {\n    text-decoration: underline;\n}\n\n.success-text {\n    margin-top: 1.5rem;\n    color: #16a34a;\n    font-weight: 600;\n    font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
